import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * Per-phase client sign-off config (toggle + approver), saved in bulk from Manage Phases.
 * Proxies through graphql/ to the client workspace's internal admin API.
 *
 * Selecting the phase NODES is what makes a save visible. The config type carries no id,
 * so a config-only payload lands in records nothing references and the store keeps the
 * pre-save value — the phase's sign-off cell and the inherited approver label on each of
 * its task rows both read a stale value until an unrelated refetch. With the node, Relay
 * merges by global id, and because a task's `phase` link and the project's `phases`
 * connection normalize to the same record, one merge updates every one of those surfaces.
 */
const mutation = graphql`
	mutation bulkUpdatePhasePortalConfigMutation($input: BulkUpdatePhasePortalConfigInput!) {
		bulkUpdatePhasePortalConfig(input: $input) {
			phases {
				id
				portalConfig {
					requiresClientSignoff
					signoffApproverPortalUserId
					signoffLocked
					signoffLockedAt
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
